import { Injectable } from '@angular/core';
import { uuid } from '@nk/utils-lib';
import { ReplaySubject } from 'rxjs';

@Injectable()
export abstract class SessionService {
  private _sessionUuidSubject = new ReplaySubject<string | null>(1);
  public sessionUuid$ = this._sessionUuidSubject.asObservable();
  public sessionUuid: string | null = null;

  private _customerSlugSubject = new ReplaySubject<string | null>(1);
  public customerSlug$ = this._customerSlugSubject.asObservable();
  public customerSlug: string | null = null;

  constructor() {
    const sessionUuid = uuid();
    this.setSessionUuid(sessionUuid);

    const customerSlug = localStorage.getItem('customer_slug');

    if (customerSlug) {
      this.setCustomerSlug(customerSlug);
    } else {
      console.warn('Customer slug is not set', customerSlug);
    }
  }

  public setSessionUuid(sessionUuid: string): void {
    this.sessionUuid = sessionUuid;
    this._sessionUuidSubject.next(sessionUuid);
  }

  public setCustomerSlug(customerSlug: string): void {
    console.info('Set customer slug', customerSlug);
    this.customerSlug = customerSlug;
    localStorage.setItem('customer_slug', customerSlug);
    this._customerSlugSubject.next(customerSlug);
  }

  public removeCustomerSlug(): void {
    this.customerSlug = null;
    localStorage.removeItem('customer_slug');
    this._customerSlugSubject.next(null);
  }
}
